<template>
  <div :id="id" class="tag" :class="{ 'tag--has-icon': showIcon }">
    <span class="tag__label">
      <slot />
    </span>
    <b-icon v-if="showIcon" class="tag__icon" icon="plus-circle-fill" />
  </div>
</template>

<script>
  export default {
    props: {
      showIcon: {
        type: Boolean,
        default: false,
      },
      id: {
        type: String,
        default: '',
      },
    },
  }
</script>

<style lang="scss" src="./Tag.scss"></style>
